import { Box, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import ArrowDownSVG from "../../../../../../../media/images/icons/arrow-down";
import KarenCoin from "../../../../../../../media/images/icons/karenCoin.svg";
import CarCancle from "../../../../../../../media/images/icons/car-cancle";
import CustomButton from "../../../../../../components/CustomButton";
import BoxChecked from "../../../../../../../media/images/icons/boxchecked";

export default function FerightDetails() {
  const theme = useTheme();

  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        mt: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box
          onClick={() => setOpen((prev) => !prev)}
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "4px",
            border: "1px solid gray",
            borderRadius: "4px",
            gap: "4px",
          }}
        >
          <Typography
            sx={{
              color: "info.main",
              fontWeight: "600",
            }}
          >
            مشاهده جزئیات بار
          </Typography>
          <ArrowDownSVG size={20} color={theme.palette.info.main} />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            paddingX: "8px",
            paddingY: "8px",
            borderRadius: "8px",
            width: "fit-content",
            backgroundColor: "#424242",
          }}
        >
          <img width={18} src={KarenCoin} alt="" />
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "600",
            }}
            color={"#FFD54F"}
          >
            477
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "600",
            }}
            color={"#FFD54F"}
          >
            امتیاز کارن کلاب{" "}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          //   border: "1px solid gray",
          height: open ? "100px" : 0,
          transition: "height 0.3s ease",
        }}
      ></Box>
      <Box
        sx={{
          mt: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <CustomButton
          // loading
          flexDirection="row-reverse"
          //   onClick={() => appDispatch(changeLoginType())}
          title="پیشنهاد  کرایه"
          bgColor="primary.main"
          textColor="#fff"
          width="48%"
          fSize="16px"
          borderColor="error.main"
          fontWeight={600}
          px="10px"
          py="12px"
          borderRadius="10px"
          color="lightStatic.main"
          //   icon1={<CarCancle size={22} color={theme.palette.error.main} />}
        />
        <CustomButton
          // loading
          flexDirection="row-reverse"
          //   onClick={() => appDispatch(changeLoginType())}
          title="دریافت بار"
          bgColor="success.main"
          textColor="#fff"
          width="48%"
          fSize="16px"
          borderColor="error.main"
          fontWeight={600}
          px="10px"
          py="12px"
          borderRadius="10px"
          color="lightStatic.main"
          icon1={<BoxChecked size={22} color={"#fff"} />}
        />
      </Box>
    </Box>
  );
}
